// MeRedirect — bounces /me → /u/{current user id}.
// Sits between the router and Profile so users always have a stable "my page" URL,
// even if they arrive from an external share or a stale bookmark.
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function MeRedirect() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && !user) nav("/auth", { replace: true });
  }, [loading, user, nav]);

  if (loading) return <div className="p-8 text-center text-white/50 text-xs tracking-widest font-display" data-testid="me-loading">// LOADING PROFILE…</div>;
  if (!user) return null;
  return <Navigate to={`/u/${user.id}`} replace />;
}
